import React, { MouseEventHandler, useContext } from "react";
import { FormattedMessage } from "react-intl";
import { Link, LinkProps, useHistory } from "react-router-dom";
import { getRoutes } from "../pages/LandingPage/LandingPageHelpers";
import { useFlags } from "launchdarkly-react-client-sdk";
import { AppStore } from "../app/store";
import { getYearPartInfo } from "../helpers/yearPartHelpers";

/**
 * BeneNewPlanSearchLink renders a link to the questions page which is after the
 * landing page to start a new plan search for a logged-in bene
 * @param props
 * @param [props.messageId] - Key for translation (not a translated string)
 * @param [props.beforeRoutingCallback] - Function to call before routing
 */
export const BeneNewPlanSearchLink: React.FC<Omit<LinkProps, "to"> & {
  messageId?: string;
  beforeRoutingCallback?: () => void;
}> = ({
  className = "",
  beforeRoutingCallback = () => {
    return;
  },
  messageId = "landing_page.shop_for_next_year_plans",
  ...props
} = {}) => {
  const {
    state: { year = "" },
  } = useContext(AppStore.AppContext);
  const flags = useFlags();
  const routerHistory = useHistory();
  let linkRoute = "/";
  // If LD flag logic is missing, go all the way to the home page
  if (
    !flags ||
    typeof flags.mctCurrentPlanYear === "undefined" ||
    typeof flags.mctYearPart === "undefined"
  ) {
    return (
      <Link to="/" className={className} {...props}>
        <FormattedMessage id={messageId} values={{ year }} />
      </Link>
    );
  }
  const { beneRouteForNextYear, beneRouteForThisYear } = getRoutes(
    flags.mctCurrentPlanYear
  );
  const { isOutsideOpenEnrollment } = getYearPartInfo(flags);

  linkRoute = !isOutsideOpenEnrollment
    ? beneRouteForNextYear
    : beneRouteForThisYear;
  const clickHandler: MouseEventHandler<HTMLAnchorElement> = e => {
    e.preventDefault();
    beforeRoutingCallback();
    routerHistory.push(linkRoute);
  };
  return (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <a href={linkRoute} onClick={clickHandler} className={className} {...props}>
      {/* The formatted message will pass a plan year to the message if it takes
          year params, as the default does. Otherwise, that value just goes unused */}
      <FormattedMessage
        id={messageId}
        values={{
          year: !isOutsideOpenEnrollment
            ? flags.mctCurrentPlanYear + 1
            : flags.mctCurrentPlanYear,
        }}
      />
    </a>
  );
};
